import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Clock, Crown } from "lucide-react";

export default function ContestPage() {
  const [c, setC] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contests/active").then((r) => setC(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (!c) return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 text-center">
      <h1 className="font-fredoka text-3xl font-bold" data-testid="contest-empty">No active contest 🌱</h1>
      <p className="text-slate-500 mt-2">Check back soon — we love a good neighborly competition.</p>
    </div>
  );

  const remaining = Math.max(0, new Date(c.end_at).getTime() - Date.now());
  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <div className="card-clay p-6 bg-gradient-to-br from-amber-100 to-orange-50 border-amber-300" data-testid="contest-card">
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 rounded-2xl bg-amber-500 border-b-4 border-amber-700 flex items-center justify-center">
            <Trophy className="text-white" strokeWidth={2.5}/>
          </div>
          <div>
            <h1 className="font-fredoka text-3xl font-bold text-slate-900">{c.title}</h1>
            <div className="text-sm text-amber-900 mt-0.5"><b>Prize:</b> {c.prize}</div>
          </div>
        </div>
        <div className="mt-4 flex items-center gap-2 text-amber-900 font-bold">
          <Clock size={16}/> Ends in {days}d {hours}h
        </div>
      </div>

      <h2 className="font-fredoka text-xl font-bold mt-6 mb-3 flex items-center gap-2"><Crown className="text-amber-500"/> Live leaderboard</h2>
      <div className="card-clay overflow-hidden">
        <ul className="divide-y divide-slate-100" data-testid="contest-leaderboard">
          {(c.leaderboard || []).length === 0 ? (
            <li className="p-6 text-center text-slate-400">No referrals yet — start sharing your code!</li>
          ) : c.leaderboard.map((row, i) => (
            <li key={i} className="flex items-center gap-3 p-4" data-testid={`contest-row-${i}`}>
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center font-fredoka font-bold ${i === 0 ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-700"}`}>{i + 1}</div>
              <div className="flex-1 font-semibold">{row.display_name}</div>
              <div className="font-fredoka font-bold text-lg">{row.count}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
